import React from 'react'

interface ButtonProps {
  primary?: boolean
  variant?: 'danger' | 'success'
  size?: 'compact' | 'regular' | 'large'
  disabled?: boolean
  href?: string
  classes?: string[]
}

export const Button: React.FC<ButtonProps> = ({
  primary = false,
  variant,
  size = 'regular',
  disabled = false,
  href,
  classes = [],
  children,
}) => {
  const classNames = ['stk-button']

  if (!!variant) {
    classNames.push(`stk-button--${variant}`)
  }

  if (primary) {
    classNames.push(`stk-button--primary`)
  }

  if (size !== 'regular') {
    classNames.push(`stk-button--${size}`)
  }

  if (disabled) {
    classNames.push(`stk-button--disabled`)
  }

  classNames.push(...(classes || []))

  const className = classNames.join(' ')

  if (href) {
    return (
      <a className={className} href={href}>
        {children}
      </a>
    )
  }

  return <button className={className}>{children}</button>
}
